module.exports = __webpack_public_path__ + "static/img/kong.ada1471.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img/kong.png
// module id = 9abD
// module chunks = 0